import React, { Component } from 'react';
import Body from './HTMLRender';
 
class Answer extends Component {
    handleClick = () => {
        this.props.handleSubmitFor(this.props.item);
    }
    render(){
        return (
            <button className="multiple-choice-button" onClick={()=>this.handleClick()}>
            <Body value={this.props.item} text={this.props.item.data} />
        </button>
        )
    }
}

export default Answer;